import { cn } from "@/lib/utils";
import "./spinner.css";

const bars = Array(12).fill(0);

export const Loader = ({ className }: { className?: string }) => {
  return (
    <div className={cn("loader-loading-wrapper", className)}>
      <div className="loader-spinner">
        {bars.map((_, i) => (
          <div className="loader-loading-bar" key={`spinner-bar-${i}`} />
        ))}
      </div>
    </div>
  );
};

export default Loader;
